import React, { useState } from "react";
import { HiArrowNarrowRight } from "react-icons/hi";
import { FaGithub } from "react-icons/fa";
import { Link } from "react-scroll";

export const Home = () => {
  const [but, setNav] = useState(false);
  const handleClick = () => setNav(!but);
  return (
    <div name="home" className="w-full h-screen bg-[#0a192f]">
      {/* Container */}
      <div className="max-w-[1000px] mx-auto px-8 flex flex-col justify-center h-full">
        <p className="text-violet-600">Hi, my name is</p>
        <h1 className="text-4xl sm:text-7xl font-bold text-[#ccd6f6]">Ivan</h1>
        <h2 className="text-4xl sm:text-7xl font-bold text-[#8892b0]">
          DevOps Engineer and SRE
        </h2>
        <p className="text-[#8892b0] py-4 max-w-[700px]">
          I am passionate about automating workflows, leveraging AI tools, and driving efficiency through innovative solutions.
        </p>
        <div>
          <div className="flex">
            <Link to="tech-stack" smooth={true} duration={500} offset={-80}>
              <button className="text-white group border-2 px-6 py-3 my-2 flex items-center hover:bg-violet-600 hover:border-violet-600 mr-2">
                Tech Stack
                <span className="group-hover:rotate-90 duration-300">
                  <HiArrowNarrowRight className="ml-3" />
                </span>
              </button>
            </Link>
            <Link to="about" smooth={true} duration={500} offset={-80}>
              <button className="text-white group border-2 px-6 py-3 my-2 flex items-center hover:bg-violet-600 hover:border-violet-600">
                About
                <span className="group-hover:rotate-90 duration-300">
                  <HiArrowNarrowRight className="ml-3" />
                </span>
              </button>
            </Link>
            <a href="https://github.com/red512" target="_blank" rel="noopener noreferrer">
              <button className="text-white group border-2 px-6 py-3 my-2 flex items-center justify-center hover:bg-violet-600 hover:border-violet-600 ml-2">
                <FaGithub className="text-2xl" />
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
